import React from 'react';
import Callable from '../../../../shared/Callable';
import ErrorCircle from '../../../../_styles/images/new-icons/driver-status/error_circle.svg';
import CheckCircle from '../../../../_styles/images/new-icons/driver-status/CheckCircle.png';
import InfoCircle from '../../../../_styles/images/new-icons/driver-status/info_circle.svg';
import { useEffect, useRef, useState } from 'react';
import analyticsService from './../../../../shared/analytics/analytics-service';
import blueCar from '../../../../_styles/images/CompleteRideBlue.png';
import orangeCar from '../../../../_styles/images/CompleteRideOrange.png';

function getTextForStatus(statusInfo, driver){
  const isHawaii = !!(driver && driver.state && driver.state.toLowerCase().includes('hawaii'));

  switch(statusInfo && statusInfo.status) {
    case 'pending' : 
          if(isHawaii) { 
            return <div className='warning-text' tabIndex={0}>Your motor vehicle report is in progress; please contact your local Enterprise branch for additional information and next steps.</div>
          } 
          else if(statusInfo.newException){
              return <div className='warning-text' tabIndex={0}>Your license is currently pending approval and may take up to 2 business days. You will not be able to drive the Commute vehicle until it has fully been approved</div>
          }
          else {
            return <div className='warning-text' tabIndex={0}>Your motor vehicle report is in progress. Please allow up to 48 hours for confirmation.</div>
          };
    case 'declined': 
    if(statusInfo.isExpiredWithin30days){
        if(isHawaii) {
        return <div className='warning-text' tabIndex={0}>Your driver's license has expired; please contact your local Enterprise branch for additional information and next steps. You must renew your license before you can operate a Commute vehicle.</div>
      } else {
        return <div className='warning-text' tabIndex={0}>Your driver's license has expired; you must renew your license before you can operate a Commute vehicle.</div>
      }
    }else{
          if(isHawaii) { 
            return <div className='warning-text' tabIndex={0}>Unfortunately, there is an issue approving your license; please call <span className='mobile-only'><Callable phone="800 VAN 4 WORK"/></span><span className='desktop-only'>800 VAN 4 WORK</span> Option 3 for additional information. In the meantime, you will not be able to drive a Commute vehicle.</div>
          } 
          else {
          return <div className='warning-text' tabIndex={0}>Unfortunately, there is an issue approving your license. If you believe this is in error, please call <span className='mobile-only'><Callable phone="800 VAN 4 WORK"/></span><span className='desktop-only'>800 VAN 4 WORK</span> Option 3 for assistance. In the meantime, you will not be able to drive a Commute vehicle.</div>;
          };
        }
    case 'expiring': return <div className='warning-text' tabIndex={0}>To continue driving a Commute vehicle, you must renew your license; we'll confirm your renewal 5 days before the expiration date.</div>
    case 'expiring today': return <div className='warning-text' tabIndex={0}>Renew by {statusInfo.dateInfo} to continue driving.</div>
    case 'expired':
      if(isHawaii) {
        return <div className='warning-text' tabIndex={0}>Your driver's license has expired. Please contact your local Enterprise branch for additional information and next steps.</div>
      } else {
        return <div className='warning-text' tabIndex={0}>Your driver's license has expired. You must renew your license before you can operate a Commute vehicle.</div>
      }
    default : return <div className='warning-text' tabIndex={0}>N/A</div>
  }
}

function getIconForStatus(statusInfo){
  switch(statusInfo.status){
    case 'pending': 
    return statusInfo.newException ? InfoCircle : blueCar;
    case 'expiring': return orangeCar;
    case 'confirm': return CheckCircle;
    case 'declined': return ErrorCircle;
    default : return ErrorCircle;
  }
}

function getHeadingForStatus(statusInfo){
  switch(statusInfo.status){
    case 'pending': return statusInfo.newException ? 'pending' : 'Pending Renewal';
    case 'declined': return 'declined';
    case 'expiring': return "Driver's License Expiring Soon";
    case 'expiring today': return 'License expires today.';
    case 'expired': return 'declined';
    case 'approved': return 'approved';
    default : return 'N/A';
  }
}

function isHawaii(driver){
  return !!(driver && driver.state && driver.state.toLowerCase().includes('hawaii'));
}

function getBannerTopic(statusInfo, driver){
  const hawaii = isHawaii(driver);

  switch(statusInfo && statusInfo.status){
    case 'pending':
       return hawaii ? 'driver license/pending-hawaii' : 'driver license/pending';
    case 'declined':
      if(statusInfo.expired){
        return hawaii ? 'driver license/declined-expired-hawaii' : 'driver license/declined-expired';
      }
      return hawaii ? 'driver license/declined-hawaii' : 'driver license/declined-declined';
    case 'expiring': return 'driver license/expiring soon';
    case 'expired':
      return hawaii ? 'driver license/declined-expired-hawaii' : 'driver license/declined-expired';
    default: return null;
  }
}

function callBannerAnalytics(bannerTopic){
  analyticsService.analyticsProcessEvent({
    "event": "banner view",
    "context": {
      "event_action": "banner view",
      "banner_topic": bannerTopic,
      "banner_count": 1
    }
  });
}

export function DriverStatus(props) {

  const [heading, setHeading] = useState("");
  const [icon, setIcon] = useState(null);
  const [text, setText] = useState("");
  const lastBannerTopic = useRef(null);

  useEffect(() => {
    if(props.statusInfo && props.statusInfo.status && props.statusInfo.status){
      const tempHeading = getHeadingForStatus(props.statusInfo);
      const tempIcon = getIconForStatus(props.statusInfo);
      const tempText = getTextForStatus(props.statusInfo, props.driver);
      var messageArray = tempText && tempText.props && tempText.props.children || [];
      var stringOnly;
      if(typeof messageArray === 'string'){
        stringOnly = messageArray;
      }else {
        stringOnly = messageArray.filter(item => typeof item === "string").join(" ");
      }
      
      // if(tempHeading !== heading){
      // analyticsService.analyticsProcessEvent({
      //   "event": "notification",
      //   "context": {
      //     'title' : tempHeading,
      //     'message' : stringOnly
      //   }
      // });
      // }
      const tempBannerTopic = getBannerTopic(props.statusInfo, props.driver);
      const isProfileDataReady = props.profileLoaded && (props.fromProfile || props.onlyPersonalProfile);
      if(isProfileDataReady && tempBannerTopic && tempBannerTopic !== lastBannerTopic.current){
        callBannerAnalytics(tempBannerTopic);
        lastBannerTopic.current = tempBannerTopic;
      }
      setHeading(tempHeading);
      setIcon(tempIcon);
      setText(tempText);
    }
  }, [props.statusInfo, props.isPreferenceChanging, props.profileLoaded, props.fromProfile, props.onlyPersonalProfile])

  return (
    props && props.statusInfo && !(props.statusInfo.status === 'approved' && props.statusInfo.dayDiff > 30) &&
    <div className={'status-content ' + props.statusInfo.status}>
      <div className='warning-icon'>
        <img className='tick-icon' src={icon} alt="image icon" />
      </div>
      <div className='content-text'>
        <div className='warning-heading'>
          {heading}
        </div>
          {text}
      </div>
    </div>
  );
}